<script setup lang="ts">
import EditDeptDrawer from '@/pages/erp/du/org/view/du-department-drawer.vue'
import type { DeptProperties } from '@/pages/erp/du/org/db/du-department-types'
import Swal from 'sweetalert2'
definePage({
    meta: {
        action: 'manage',
        subject: 'DUDEPARTMENT',
    },
})

const compId = ref(useStorage('compNo').value)
const orgType = ref()
const depNo = ref()

// Data table options
const currentPage = ref(1)
const size = ref(10)
const sortOrder = ref()
const orderByCol = ref()

// Update data table options
const updateOptions = (options: any) => {
  sortOrder.value = options.sortBy[0]?.key
  orderByCol.value = options.sortBy[0]?.order
}

// Headers

const grid1Headers = [
    { title: '公司ID', key: 'compId' },
    { title: '組織類別', key: 'orgType' },
    { title: '部門代號', key: 'depNo' },
    { title: '部門名稱', key: 'depName' },
    { title: '狀態', key: 'status' },
    { title: '操作', key: 'actions', sortable: false}
]


// champ 後端分頁是從 0 開始
const page = computed((): number => currentPage.value - 1)

// 👉 Fetching users
const { data: deptsData, execute: fetchDepts } = await useApi<any>(createUrl('/du/org/department/searchDept', {
  query: {
    compId,
    orgType,
    depNo,
    page,
    size,
    orderByCol,
    sortOrder,
  },
}))

const datas = computed((): DeptProperties[] => deptsData.value.data.deptPage.content)
const totalDatas = computed(() => deptsData.value.data.deptPage.totalElements)

console.log('datas: ', datas)

const isEditDataDrawerVisible = ref(false)
const isNewData = ref(false)
const isCopyData = ref(false)

let voData = {}


const createData = () => {
  isEditDataDrawerVisible.value = true
  isNewData.value = true
  isCopyData.value = false
}

const editData = (deptData: DeptProperties) => {
  voData = deptData
  console.log('editDept: ', voData)
  isEditDataDrawerVisible.value = true
  isNewData.value = false
  isCopyData.value = false
}

const copyData = (deptData: DeptProperties) => {
    voData = deptData
    console.log('copyDept: ', voData)
    isEditDataDrawerVisible.value = true
    isNewData.value = true
    isCopyData.value = true
}

// 👉 Add new data
const addNewData = async (deptData: DeptProperties) => {
  await $api('/du/org/department/createDept', {
    method: 'POST',
    body: { dept: deptData },
  }).then(() => {
      $swal({
      position: 'top-end',
      icon: 'success',
      title: '新增成功',
      showConfirmButton: false,
      timer: 1500,
      customClass: {
        confirmButton: 'btn btn-primary',
      },
      buttonsStyling: false,
    })
  })

  // refetch data
  fetchDepts()
}

const updateData = async (deptData: DeptProperties) => {
  await $api('/du/org/department/updateDept', {
    method: 'PUT',
    body: { dept: deptData },
  }).then(() => {
      $swal({
      position: 'top-end',
      icon: 'success',
      title: '修改成功',
      showConfirmButton: false,
      timer: 1500,
      customClass: {
        confirmButton: 'btn btn-primary',
      },
      buttonsStyling: false,
    })
  })

  // refetch data
  fetchDepts()
}

  // 👉 Delete data
const deleteData = async (deptData: DeptProperties) => {
  const { orgType,depNo } = deptData
    $swal({
    title: `確定要刪除 ${deptData.depName} 資料?`,
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "確定",
    cancelButtonText: "取消"
  }).then((result) => {
    if (result.isConfirmed) {
        $api(`/du/org/department/deleteDept`, {
        method: 'DELETE',
        query: {
          orgType,depNo
        }
      }).then(() => {
          $swal({
          position: 'top-end',
          title: "刪除成功",
          timer: 1500,
          icon: "success"
        });

        // refetch Data
        fetchDepts()
      })
    }
  });

}

const clickRow = (event, select) => {
  console.log('clickRow: ', event, select)
  editData(select.item)
}

</script>

<template>
  <!-- 👉 Widgets -->

  <VCard class="mb-6">
    <VCardItem class="pb-2 pt-2">
      <VCardTitle>搜尋</VCardTitle>
    </VCardItem>

    <VCardText>
      <VRow>
        <VCol
         cols="12"
         sm="2"
        >
          <AppTextField
            v-model="compId"
            clearable
            clear-icon="mdi-close-circle"
            placeholder="請輸入公司ID"
          />
        </VCol>
        <VCol
         cols="12"
         sm="2"
        >
          <AppTextField
            v-model="orgType"
            clearable
            clear-icon="mdi-close-circle"
            placeholder="請輸入組織類別"
          />
        </VCol>
        <VCol
         cols="12"
         sm="2"
        >
          <AppTextField
            v-model="depNo"
            clearable
            clear-icon="mdi-close-circle"
            placeholder="請輸入部門代號"
          />
        </VCol>
      </VRow>
    </VCardText>

    <VDivider />

    <VCardText class="d-flex flex-wrap gap-4">
      <VSpacer />

      <div class="app-user-search-filter d-flex align-center flex-wrap gap-4">
        <!-- 👉 Add button -->
        <VBtn
                prepend-icon="tabler-plus"
                @click="createData"
        >
          新增部門
        </VBtn>
      </div>
    </VCardText>

    <VDivider />

    <!-- SECTION datatable -->
    <VDataTableServer
            v-model:items-per-page="size"
            v-model:page="currentPage"
            :items="datas"
            :items-length="totalDatas"
            :headers="grid1Headers"
            class="text-no-wrap"
            @update:options="updateOptions"
    >

      <template #item.compId="{ item }">
          <div class="text-body-1 text-high-emphasis">
              {{ item.compId }}
          </div>
      </template>

      <template #item.orgType="{ item }">
          <div class="text-body-1 text-high-emphasis">
              {{ item.orgType }}
          </div>
      </template>

      <template #item.depNo="{ item }">
          <div class="text-body-1 text-high-emphasis">
              {{ item.depNo }}
          </div>
      </template>

      <template #item.depName="{ item }">
          <div class="text-body-1 text-high-emphasis">
              {{ item.depName }}
          </div>
      </template>

      <template #item.status="{ item }">
          <div class="text-body-1 text-high-emphasis">
              {{ item.status }}
          </div>
      </template>

      <!-- Actions -->
      <template #item.actions="{ item }">
          <IconBtn @click="editData(item)">
              <VIcon icon="tabler-edit" />
              <v-tooltip
                      activator="parent"
                      location="bottom"
              >編輯</v-tooltip>
          </IconBtn>
          <IconBtn @click="copyData(item)">
              <VIcon icon="tabler-copy" />
              <v-tooltip
                      activator="parent"
                      location="bottom"
              >複製</v-tooltip>
          </IconBtn>
          <IconBtn @click="deleteData(item)">
              <VIcon icon="tabler-trash" />
              <v-tooltip
                      activator="parent"
                      location="bottom"
              >刪除</v-tooltip>
          </IconBtn>
      </template>

      <!-- pagination -->
      <template #bottom>
        <TablePagination
                v-model:page="currentPage"
                v-model:size="size"
                :items-per-page="size"
                :total-items="totalDatas"
        />
      </template>
    </VDataTableServer>
    <!-- SECTION -->
  </VCard>
  <!-- 👉 Edit -->
  <EditDeptDrawer
          v-model:isDrawerOpen="isEditDataDrawerVisible"
          :dept-data="voData"
          :is-new="isNewData"
          :is-copy="isCopyData"
          @create-data="addNewData"
          @update-data="updateData"
  />

</template>
